<div class="wrapper-product-data-and-controls">
  <div class="wrapper-left-side">
    <ui-page-header>Produktdetails</ui-page-header>

    <ui-product-detail-header
      [detailsDataScrollElement]="productDetailInfoComponent.headline?.nativeElement"
      [product]="product()">
    </ui-product-detail-header>

    <!-- we need this additional wrapper in order to hide it on desktop without javascript --->
    <div class="wrapper-prices-and-controls-responsive">
      <ng-container *ngTemplateOutlet="pricesAndControls"></ng-container>
    </div>

    @let productDescription = product().details.description?.trim();

    @if (productDescription) {
      <div class="wrapper-product-description">
        <h6>Produktbeschreibung</h6>
        <p>{{ productDescription }}</p>
      </div>
    }

    <ui-product-detail-info
      #productDetailInfoComponent
      [product]="product()"
    ></ui-product-detail-info>
  </div>
  <div class="wrapper-right-side">
    <ng-container *ngTemplateOutlet="pricesAndControls"></ng-container>
  </div>
</div>

<ng-template #pricesAndControls>
  <!--
  This ui element is sticky on desktop. Because of this the wrapper needs have the full height.
  In order for the sticky positioning to work. So we need to render this in 2 different places.
  1. for desktop in the right side div
  2. for tablet / mobile below the image and detail data.
  Additionally we avoid doing some weird calculations.
  -->
  <div class="wrapper-prices-and-controls">
    @if (product().prices; as prices) {
      <ui-product-detail-prices [prices]="prices"></ui-product-detail-prices>
    }

    <ui-add-to-cart
      [sku]="product().sku"
      [orderButtonDisabled]="!productHasPrice()"
      [class.with-prices]="productPriceIsVisible()"
      [showButtonLabels]="false"
      [showAddToShoppingList]="true"
      [defaultAmount]="1"
      [product]="product()"
      [position]="0"
      (addToShoppingListClicked)="onAddToShoppingList($event)"
    ></ui-add-to-cart>
  </div>
</ng-template>
